<script>
import { useVuelidate } from '@vuelidate/core';
import { helpers } from '@vuelidate/validators';
import { useAlert } from 'dashboard/composables';
import FormButton from 'v3/components/Form/Button.vue';
import { mapGetters } from 'vuex';

// Mirrors PhoneCredential::SIP_USERNAME_FORMAT. The username becomes the user
// part of `sip:<username>@<sip_host>`, so an email address here produces a uri
// the SIP stack refuses to parse.
const SIP_USERNAME = /^[a-zA-Z0-9_.\-+]{1,64}$/;

export default {
  components: {
    FormButton,
  },
  props: {},
  setup() {
    return { v$: useVuelidate() };
  },
  data() {
    return {
      enteredUsername: '',
      enteredPassword: '',
      inputStyles: {
        borderRadius: '12px',
        padding: '6px 12px',
        fontSize: '14px',
        marginBottom: '2px',
      },
    };
  },
  computed: {
    ...mapGetters({
      uiFlags: 'userPhoneCredentials/getUIFlags',
      credentials: 'userPhoneCredentials/getCredentials',
    }),
  },
  validations: {
    enteredUsername: {
      format: helpers.regex(SIP_USERNAME),
    },
  },
  watch: {
    credentials(record) {
      this.enteredUsername = record.username;
      this.enteredPassword = record.password;
    },
  },
  mounted() {
    this.$store.dispatch('userPhoneCredentials/get');
  },
  methods: {
    async updateCredentials() {
      this.v$.$touch();
      if (this.v$.$invalid) return;

      let alertMessage = '';
      try {
        await this.$store.dispatch('userPhoneCredentials/update', {
          username: this.enteredUsername,
          password: this.enteredPassword,
        });
        alertMessage = this.$t('PROFILE_SETTINGS.UPDATE_SUCCESS');
      } catch (error) {
        alertMessage = this.credentialErrorMessage(error);
      } finally {
        useAlert(alertMessage);
      }
    },
    credentialErrorMessage(error) {
      const fieldErrors = error?.response?.data?.errors;
      const messages = Object.entries(fieldErrors || {})
        .map(([field, details]) => {
          const detail = Array.isArray(details) ? details[0] : details;
          if (field === 'username' && detail?.error === 'invalid') {
            return this.$t(
              'PROFILE_SETTINGS.FORM.PHONE_SETTINGS.API.USERNAME_INVALID'
            );
          }
          if (detail?.error !== 'taken') return null;
          if (field === 'username') {
            return this.$t(
              'PROFILE_SETTINGS.FORM.PHONE_SETTINGS.API.USERNAME_TAKEN'
            );
          }
          return null;
        })
        .filter(Boolean);
      return messages.length
        ? messages.join(' ')
        : this.$t('PROFILE_SETTINGS.FORM.API.UPDATE_ERROR');
    },
  },
};
</script>

<template>
  <form class="flex flex-col gap-4" @submit.prevent="updateCredentials()">
    <woot-input
      v-model="enteredUsername"
      :styles="inputStyles"
      :class="{ error: v$.enteredUsername.$error }"
      :label="$t('PROFILE_SETTINGS.FORM.PHONE_SETTINGS.USERNAME')"
      :error="
        v$.enteredUsername.$error
          ? $t('PROFILE_SETTINGS.FORM.PHONE_SETTINGS.USERNAME_INVALID')
          : ''
      "
      @blur="v$.enteredUsername.$touch"
    />
    <woot-input
      v-model="enteredPassword"
      type="password"
      :styles="inputStyles"
      :label="$t('PROFILE_SETTINGS.FORM.PHONE_SETTINGS.PASSWORD')"
    />
    <FormButton
      type="submit"
      color-scheme="primary"
      variant="solid"
      size="large"
      :disabled="uiFlags.isUpdating"
    >
      {{ $t('PROFILE_SETTINGS.FORM.PHONE_SETTINGS.SUBMIT') }}
    </FormButton>
  </form>
</template>
